import React, { useState } from "react";
import { useCampaignDetail } from "../CampaignDetailProvider";
import { deleteUsageRightsTemplate } from "@/services/inboundEmailTemplate.service";
import ModalComponent from "@/components/common-components/ModalComponent/ModalComponent";
import IconContainer from "@/components/common-components/FtuxComponent/IconContainer";
import ButtonComponent from "@/components/common-components/ButtonComponent/ButtonComponent";
import { NotificationManager } from 'react-notifications'

export const DeleteTemplateModal = ({ show, onClose, setDeleteTemplateModal, selectedTemplate }: { show: boolean, onClose: () => void, setDeleteTemplateModal: any, selectedTemplate: any }) => {

  const [loading, setLoading] = useState(false);

  // @ts-ignore
  const { setCurrentModal, setMessage } = useCampaignDetail()

  const handleDeleteTemplate = async () => {
    setLoading(true);
    const response = await deleteUsageRightsTemplate(selectedTemplate?._id);
    if (response?.status) {
      setCurrentModal((prev:boolean) => !prev);
      setMessage('')
      NotificationManager.success('Template Deleted', '', 1000);
      setDeleteTemplateModal(false);
    }
    setLoading(false);
  }
  return (
    <ModalComponent show={show} onClose={onClose} width={420}>
      <div className="modal-main-content">
        <div className="center">
          <IconContainer bgColor={'var(--secondary-surface-red)'} icon="🚨" />
        </div>
        <h2>Delete Template</h2>
        <p className="enter-list-name">
          Are you sure you want to delete “{selectedTemplate?.name}”?
        </p>
        <div className="modal-footer-button-container">
          <ButtonComponent onClick={() => { setDeleteTemplateModal(false) }} variant="secondary">
            Go Back
          </ButtonComponent>
          <ButtonComponent type="submit" onClick={handleDeleteTemplate} showLoading={loading} variant="danger">
            Yes, Delete
          </ButtonComponent>
        </div>
      </div>
    </ModalComponent>
  );
};